import request from "@/utils/request";

export function fetchList(params) {
  return request({
    url: "/web/articles/list",
    method: "get",
    params: params
  });
}

export function getArticleInfo(id) {
  return request({
    url: "/web/articles/info",
    method: "get",
    params: {
      id: id
    }
  });
}

export function searchArticle(keywords) {
  return request({
    url: "/articles/searchArticle",
    method: "get",
    params: {
      keywords: keywords
    }
  });
}

//分类标签id获取文章
export function queryIdToArticles(params) {
  return request({
    url: "/web/articles/list",
    method: "get",
    params: params
  });
}

export function like(id) {
  return request({
    url: "/web/likes",
    method: "post",
    data: { id }
  });
}

export function checkSecret(params) {
  return request({
    url: "/web/article/checkSecret",
    method: "get",
    params: params
  });
}

//友链页面请求接口
export function addLink(data) {
  return request({
    url: "/web/friend/add",
    method: "POST",
    data
  });
}

export function fetchFriend() {
  return request({
    url: "/web/friend/list",
    method: "post",
    params: {}
  });
}

export function getWebSiteInfo() {
  return request({
    url: "/web/home/webSiteInfo",
    method: "get",
    params: {}
  });
}

//留言接口
export function addMessage(data) {
  return request({
    url: "/web/message/add",
    method: "post",
    data
  });
}

export function listMessage() {
  return request({
    url: "/web/message/webMessage",
    method: "get",
    params: {}
  });
}

//添加评论
export function addComment(data) {
  return request({
    url: "/web/comments",
    method: "post",
    data
  });
}

//评论列表
export function fetchComments(params) {
  return request({
    url: "/comments",
    method: "get",
    params: params
  });
}

//查询回复评论
export function repliesByComId(params) {
  return request({
    url: "/web/comment/repliesByComId",
    method: "get",
    params: params
  });
}

//标签接口
export function getTags() {
  return request({
    url: "/tags",
    method: "get",
    params: {}
  });
}

//分类接口
export function getCategory() {
  return request({
    url: "/categorys/list",
    method: "get",
    params: {}
  });
}

//分类接口
export function getCategoryDetail(id) {
  return request({
    url: `/categorys/${id}`,
    method: "get"
  });
}

//标签接口
export function getTagsDetail(id) {
  return request({
    url: `/tags/${id}`,
    method: "get"
  });
}

//归档接口
export function getArchive(params) {
  return request({
    url: "/web/articles/list",
    method: "get",
    params: params
  });
}

//qq登录
export function qqLogin(data) {
  return request({
    url: "/user/login",
    method: "post",
    data
  });
}

//qq退出
export function logout() {
  return request({
    url: "/logout",
    method: "get"
  });
}

//gitee登录
export function gitEELogin(code) {
  return request({
    url: "/user/gitEELogin",
    method: "get",
    params: {
      code: code
    }
  });
}

//微博登录
export function weiboLogin(code) {
  return request({
    url: "/user/weiboLogin",
    method: "get",
    params: {
      code: code
    }
  });
}

//添加访客信息
export function report() {
  return request({
    url: "/web/home/report",
    method: "get",
    params: {}
  });
}

//相册接口
export function getAlbum() {
  return request({
    url: "/file/albums",
    method: "get",
    params: {}
  });
}

export function getPhotos(params) {
  return request({
    url: "/web/album/listPhotos",
    method: "get",
    params: params
  });
}

export function addFeedback(data) {
  return request({
    url: "/web/feedback/add",
    method: "post",
    data
  });
}

export function sendEmailCode(email) {
  return request({
    url: "/users/sendEmailCode",
    method: "post",
    data: {
      email: email
    }
  });
}

export function bindEmail(data) {
  return request({
    url: "/user/bindEmail",
    method: "post",
    data
  });
}

export function emailRegister(data) {
  return request({
    url: "/users",
    method: "post",
    data
  });
}

export function emailLogin(data) {
  return request({
    url: "/users/login",
    method: "post",
    data:{
      ...data,
      referer:'h5'
    }
  });
}

export function updatePassword(data) {
  return request({
    url: "/users/forgotPassword",
    method: "post",
    data
  });
}

export function upload(data) {
  return request({
    url: "/upload",
    method: "POST",
    headers: {
      "Content-Type": "multipart/articles-data"
    },
    data
  });
}

export function updateUser(params) {
  return request({
    url: "/web/users",
    method: "PUT",
    params
  });
}

//开始

export function tagsList(params) {
  return request({
    url: "/tags",
    method: "get",
    params
  });
}

export function informations(params) {
  return request({
    url: "/informations",
    method: "get",
    params
  });
}


export function articlesDetail(id) {
  return request({
    url: `/articles/${id}`,
    method: "get"
  });
}


export function getCounts() {
  return request({
    url: `/counts`,
    method: "get"
  });
}

export function getUserInfo() {
  return request({
    url: `web/users`,
    method: "get"
  });
}